import { Model } from "../../shared/models/model";

export class RedirectionResponse extends Model {
    public redirectTo: string;
}
